export const ELEMENTS_TYPES = {
  GREETING: 'greeting',
  SMART_PAUSE: 'smart_pause',
  MESSAGE: 'message',
  LINK_TO_MESSAGE: 'link_to_message',
  RECOGNIZE_ANSWER_GROUP_SHORT: 'recognize_answer_group_short',
  RECOGNIZE_ANSWER_GROUP_LONG: 'recognize_answer_group_long',
  RECOGNIZE_ANSWER_SHORT: 'recognize_answer_short',
  RECOGNIZE_ANSWER_LONG: 'recognize_answer_long',
  GO_TO_MESSAGE: 'go_to_message',
  GO_TO_MESSAGE_RETURN: 'go_to_message_return',
  GOODBYE: 'goodbye',
  CONVERSION: 'conversion',
  SAY_VARIABLE: 'say_variable',
  SEND_SMS: 'send_sms',
  SEND_WEBHOOK: 'send_webhook',
  CONNECT_OPERATOR: 'connect_operator',
  ADD_TO_STOPLIST: 'add_to_stoplist',
  CHANGE_RECOGNITION_LANG: 'lang',
};

export const ELEMENTS_TYPES_LABELS = {
  [ELEMENTS_TYPES.GREETING]: 'Greeting',
  [ELEMENTS_TYPES.SMART_PAUSE]: 'Smart pause',
  [ELEMENTS_TYPES.MESSAGE]: 'New message',
  [ELEMENTS_TYPES.RECOGNIZE_ANSWER_GROUP_SHORT]: 'Recognize short answer',
  [ELEMENTS_TYPES.RECOGNIZE_ANSWER_GROUP_LONG]: 'Recognize long answer',
  [ELEMENTS_TYPES.RECOGNIZE_ANSWER_SHORT]: 'Recognize short answer',
  [ELEMENTS_TYPES.RECOGNIZE_ANSWER_LONG]: 'Recognize long answer',
  [ELEMENTS_TYPES.GO_TO_MESSAGE]: 'Go to',
  [ELEMENTS_TYPES.GO_TO_MESSAGE_RETURN]: 'Go to and return',
  [ELEMENTS_TYPES.LINK_TO_MESSAGE]: 'Existing message',
  [ELEMENTS_TYPES.GOODBYE]: 'Goodbye',
  [ELEMENTS_TYPES.CONVERSION]: 'Conversion',
  [ELEMENTS_TYPES.SAY_VARIABLE]: 'Say variable',
  [ELEMENTS_TYPES.SEND_SMS]: 'Send SMS',
  [ELEMENTS_TYPES.SEND_WEBHOOK]: 'Send webhook',
  [ELEMENTS_TYPES.CONNECT_OPERATOR]: 'Connect operator',
  [ELEMENTS_TYPES.ADD_TO_STOPLIST]: 'Add to stoplist',
  [ELEMENTS_TYPES.CHANGE_RECOGNITION_LANG]: 'Change Recognition lang',
};

export const ELEMENTS_TYPES_GROUPS = {
  [ELEMENTS_TYPES.RECOGNIZE_ANSWER_GROUP_SHORT]: ELEMENTS_TYPES.RECOGNIZE_ANSWER_SHORT,
  [ELEMENTS_TYPES.RECOGNIZE_ANSWER_GROUP_LONG]: ELEMENTS_TYPES.RECOGNIZE_ANSWER_LONG,
};

export const ELEMENTS_TYPES_ALLOWED_CHILDREN = {
  [ELEMENTS_TYPES.GREETING]: [
    ELEMENTS_TYPES.SMART_PAUSE,
  ],
  [ELEMENTS_TYPES.SMART_PAUSE]: [
    ELEMENTS_TYPES.MESSAGE,
    ELEMENTS_TYPES.GO_TO_MESSAGE,
    ELEMENTS_TYPES.GO_TO_MESSAGE_RETURN,
    ELEMENTS_TYPES.GOODBYE,
    ELEMENTS_TYPES.CONVERSION,
    ELEMENTS_TYPES.SAY_VARIABLE,
    ELEMENTS_TYPES.CHANGE_RECOGNITION_LANG,
    ELEMENTS_TYPES.SEND_SMS,
    ELEMENTS_TYPES.SEND_WEBHOOK,
    ELEMENTS_TYPES.CONNECT_OPERATOR,
    ELEMENTS_TYPES.ADD_TO_STOPLIST,
  ],
  [ELEMENTS_TYPES.MESSAGE]: [
    ELEMENTS_TYPES.RECOGNIZE_ANSWER_GROUP_SHORT,
    ELEMENTS_TYPES.RECOGNIZE_ANSWER_GROUP_LONG,
    ELEMENTS_TYPES.SMART_PAUSE,
    // ELEMENTS_TYPES.MESSAGE,
    // ELEMENTS_TYPES.GO_TO_MESSAGE,
    // ELEMENTS_TYPES.GOODBYE,
    // ELEMENTS_TYPES.CONVERSION,
    // ELEMENTS_TYPES.SAY_VARIABLE,
    // ELEMENTS_TYPES.CHANGE_RECOGNITION_LANG,
    // ELEMENTS_TYPES.SEND_SMS,
    // ELEMENTS_TYPES.SEND_WEBHOOK,
    // ELEMENTS_TYPES.CONNECT_OPERATOR,
    // ELEMENTS_TYPES.ADD_TO_STOPLIST,
  ],
  [ELEMENTS_TYPES.RECOGNIZE_ANSWER_SHORT]: [
    ELEMENTS_TYPES.MESSAGE,
    ELEMENTS_TYPES.GO_TO_MESSAGE,
    ELEMENTS_TYPES.GO_TO_MESSAGE_RETURN,
    ELEMENTS_TYPES.GOODBYE,
    ELEMENTS_TYPES.CONVERSION,
    ELEMENTS_TYPES.SAY_VARIABLE,
    ELEMENTS_TYPES.CHANGE_RECOGNITION_LANG,
    ELEMENTS_TYPES.SEND_SMS,
    ELEMENTS_TYPES.SEND_WEBHOOK,
    ELEMENTS_TYPES.CONNECT_OPERATOR,
    ELEMENTS_TYPES.ADD_TO_STOPLIST,
  ],
  [ELEMENTS_TYPES.RECOGNIZE_ANSWER_LONG]: [
    ELEMENTS_TYPES.MESSAGE,
    ELEMENTS_TYPES.GO_TO_MESSAGE,
    ELEMENTS_TYPES.GO_TO_MESSAGE_RETURN,
    ELEMENTS_TYPES.GOODBYE,
    ELEMENTS_TYPES.CONVERSION,
    ELEMENTS_TYPES.SAY_VARIABLE,
    ELEMENTS_TYPES.CHANGE_RECOGNITION_LANG,
    ELEMENTS_TYPES.SEND_SMS,
    ELEMENTS_TYPES.SEND_WEBHOOK,
    ELEMENTS_TYPES.CONNECT_OPERATOR,
    ELEMENTS_TYPES.ADD_TO_STOPLIST,
  ],
  [ELEMENTS_TYPES.GO_TO_MESSAGE]: [
    ELEMENTS_TYPES.LINK_TO_MESSAGE,
  ],
  [ELEMENTS_TYPES.GO_TO_MESSAGE_RETURN]: [
    ELEMENTS_TYPES.LINK_TO_MESSAGE,
  ],
  [ELEMENTS_TYPES.GOODBYE]: false,
  [ELEMENTS_TYPES.CONVERSION]: [
    ELEMENTS_TYPES.MESSAGE,
    ELEMENTS_TYPES.GO_TO_MESSAGE,
    ELEMENTS_TYPES.GOODBYE,
    ELEMENTS_TYPES.SAY_VARIABLE,
    ELEMENTS_TYPES.CHANGE_RECOGNITION_LANG,
    ELEMENTS_TYPES.SEND_SMS,
    ELEMENTS_TYPES.SEND_WEBHOOK,
    ELEMENTS_TYPES.CONNECT_OPERATOR,
  ],
  [ELEMENTS_TYPES.SAY_VARIABLE]: [
    ELEMENTS_TYPES.MESSAGE,
    ELEMENTS_TYPES.GO_TO_MESSAGE,
    ELEMENTS_TYPES.GOODBYE,
    ELEMENTS_TYPES.CONVERSION,
    ELEMENTS_TYPES.CHANGE_RECOGNITION_LANG,
    ELEMENTS_TYPES.SEND_SMS,
    ELEMENTS_TYPES.SEND_WEBHOOK,
    ELEMENTS_TYPES.CONNECT_OPERATOR,
  ],
  [ELEMENTS_TYPES.SEND_SMS]: [
    ELEMENTS_TYPES.MESSAGE,
    ELEMENTS_TYPES.GO_TO_MESSAGE,
    ELEMENTS_TYPES.GOODBYE,
    ELEMENTS_TYPES.CONVERSION,
    ELEMENTS_TYPES.SEND_WEBHOOK,
    ELEMENTS_TYPES.SAY_VARIABLE,
    ELEMENTS_TYPES.CHANGE_RECOGNITION_LANG,
    ELEMENTS_TYPES.CONNECT_OPERATOR,
  ],
  [ELEMENTS_TYPES.SEND_WEBHOOK]: [
    ELEMENTS_TYPES.MESSAGE,
    ELEMENTS_TYPES.GO_TO_MESSAGE,
    ELEMENTS_TYPES.GOODBYE,
    ELEMENTS_TYPES.CONVERSION,
    ELEMENTS_TYPES.SEND_SMS,
    ELEMENTS_TYPES.SAY_VARIABLE,
    ELEMENTS_TYPES.CHANGE_RECOGNITION_LANG,
    ELEMENTS_TYPES.CONNECT_OPERATOR,
  ],
  [ELEMENTS_TYPES.CHANGE_RECOGNITION_LANG]: [
    ELEMENTS_TYPES.MESSAGE,
    ELEMENTS_TYPES.GO_TO_MESSAGE,
    ELEMENTS_TYPES.GOODBYE,
    ELEMENTS_TYPES.CONVERSION,
    ELEMENTS_TYPES.SEND_SMS,
    ELEMENTS_TYPES.SAY_VARIABLE,
    ELEMENTS_TYPES.SEND_WEBHOOK,
    ELEMENTS_TYPES.CONNECT_OPERATOR,
  ],
  [ELEMENTS_TYPES.CONNECT_OPERATOR]: false,
  [ELEMENTS_TYPES.ADD_TO_STOPLIST]: [
    ELEMENTS_TYPES.MESSAGE,
    ELEMENTS_TYPES.GO_TO_MESSAGE,
    ELEMENTS_TYPES.GOODBYE,
    ELEMENTS_TYPES.CONVERSION,
    ELEMENTS_TYPES.SEND_WEBHOOK,
    ELEMENTS_TYPES.SAY_VARIABLE,
    ELEMENTS_TYPES.CHANGE_RECOGNITION_LANG,
    ELEMENTS_TYPES.CONNECT_OPERATOR,
  ],
};

export const ELEMENTS_TYPES_RELATIONS = {
  [ELEMENTS_TYPES.LINK_TO_MESSAGE]: [
    ELEMENTS_TYPES.MESSAGE,
  ],
};

export const ELEMENTS_TYPES_ALLOWED_RECORD = [
  ELEMENTS_TYPES.GREETING,
  ELEMENTS_TYPES.MESSAGE,
  ELEMENTS_TYPES.GOODBYE,
];

export const ELEMENTS_TYPES_ALLOWED_TEXT = [
  ELEMENTS_TYPES.GREETING,
  ELEMENTS_TYPES.MESSAGE,
  ELEMENTS_TYPES.RECOGNIZE_ANSWER_SHORT,
  ELEMENTS_TYPES.RECOGNIZE_ANSWER_LONG,
  ELEMENTS_TYPES.SAY_VARIABLE,
  ELEMENTS_TYPES.CHANGE_RECOGNITION_LANG,
  ELEMENTS_TYPES.SEND_SMS,
  ELEMENTS_TYPES.SEND_WEBHOOK,
  ELEMENTS_TYPES.CONNECT_OPERATOR,
  ELEMENTS_TYPES.GOODBYE,
];

export const ELEMENTS_TYPES_COUNTABLE = [
  {
    key: 'messages',
    types: [
      ELEMENTS_TYPES.MESSAGE,
    ],
    label: 'Message',
    max: 50,
  },
  {
    key: 'goodbye',
    types: [
      ELEMENTS_TYPES.GOODBYE,
    ],
    // Hide count.
    // label: 'Goodbye',
    max: 50,
  },
];

export const ELEMENTS_TYPES_SECOND_MENU = [
  ELEMENTS_TYPES.GO_TO_MESSAGE,
  ELEMENTS_TYPES.GO_TO_MESSAGE_RETURN,
];

export const ELEMENTS_TYPES_RETURN = [
  ELEMENTS_TYPES.GO_TO_MESSAGE_RETURN,
];

export const AUTOCOMPLETE_ELEMENTS_TYPES = [
  ELEMENTS_TYPES.RECOGNIZE_ANSWER_LONG,
  ELEMENTS_TYPES.RECOGNIZE_ANSWER_SHORT,
];

export const AUTOCOMPLETE_OPTIONS = [
  {
    label: 'положительный ответ',
    value: 'да, давайте, давай, можно, возможно, ок, окей, хорошо, пускай, конечно, скорей да, есть, ну есть, почему бы и, хочу, интересно, буду, так',
  },
  {
    label: 'отрицательный ответ',
    value: 'не, нет, нету, не надо, не нужно, не стоит, не буду, не хочу, не интересно, скорей нет',
  },
  {
    label: 'вопрос',
    value: 'кто, что, когда, зачем, почему, где, как, какой, какая, сколько, куда, откуда, насколько, подробней',
  },
  {
    label: 'перезвонить',
    value: 'занят, занята, не сейчас, не могу, не удобно, перезвоните, перезвоню, перезвони, позже, за рулем, в машине, в метро, через',
  },
  {
    label: 'повторить',
    value: 'повторить, повторите, еще раз, не расслышала, не слышно, что что',
  },
];

export const ELEMENTS_TYPES_BRANCH = [
  ELEMENTS_TYPES.MESSAGE,
];

export const ELEMENTS_TYPES_BRANCH_ACTIONS = [
  ELEMENTS_TYPES.CONVERSION,
  ELEMENTS_TYPES.SAY_VARIABLE,
  ELEMENTS_TYPES.SEND_SMS,
  ELEMENTS_TYPES.SEND_WEBHOOK,
  ELEMENTS_TYPES.CONNECT_OPERATOR,
  ELEMENTS_TYPES.ADD_TO_STOPLIST,
  ELEMENTS_TYPES.CHANGE_RECOGNITION_LANG,
];

export const ELEMENTS_TYPES_BRANCH_ACTIONS_KEYS = {
  [ELEMENTS_TYPES.CONVERSION]: 'conversion',
  [ELEMENTS_TYPES.SAY_VARIABLE]: 'say_variable',
  [ELEMENTS_TYPES.SEND_SMS]: 'sms',
  [ELEMENTS_TYPES.SEND_WEBHOOK]: 'url',
  [ELEMENTS_TYPES.CONNECT_OPERATOR]: 'connect',
  [ELEMENTS_TYPES.ADD_TO_STOPLIST]: 'stoplist',
  [ELEMENTS_TYPES.CHANGE_RECOGNITION_LANG]: 'lang',
};

export const ELEMENTS_TYPES_BRANCH_AFTER_ACTIONS = [
  ELEMENTS_TYPES.MESSAGE,
  ELEMENTS_TYPES.LINK_TO_MESSAGE,
  ELEMENTS_TYPES.GOODBYE,
];
